import { styled, Typography, Box } from '@mui/material'
import ExternalLink from '@mui/material/Link'

export const TitleTypography = styled(Typography)(() => ({
  color: '#2b2b2b',
  fontSize: '1rem',
  fontWeight: 600,
  lineHeight: 1.4,
  marginBottom: '1rem',
  marginTop: '1rem'
}))

export const Header = styled(Box)(() => ({
  background: 'url("//content.photobucket.com/img/homepage/secondary-header-bg.webp") center center no-repeat',
  backgroundSize: 'cover',
  height: '300px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
})) as typeof Box

export const ContentWrapper = styled(Box)(({ theme }) => ({
  fontFamily: '"proxima-nova", sans-serif',
  fontSize: '1rem',
  padding: '0 20px',
  margin: '20px 0 0',
  [theme.breakpoints.up('md')]: {
    margin: '100px 0 0',
    fontSize: '1.375rem',
    padding: '0 140px'
  }
})) as typeof Box

export const Subhead = styled(Typography)(({ theme }) => ({
  fontSize: '1.75rem',
  fontWeight: 700,
  lineHeight: 1.6,
  textAlign: 'left',
  marginBottom: '10px',
  [theme.breakpoints.up('md')]: {
    fontSize: '2.25rem',
    marginBottom: '20px'
  }
}))

export const Numberedhead = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  fontWeight: 700,
  lineHeight: 1.6,
  textAlign: 'left',
  marginBottom: '20px',
  [theme.breakpoints.up('md')]: {
    fontSize: '1.75rem'
  }
}))

export const ContentText = styled(Typography)(({ theme }) => ({
  fontFamily: '"proxima-nova", sans-serif',
  fontSize: '1rem',
  lineHeight: 1.5,
  margin: '10px 0 20px',
  [theme.breakpoints.up('lg')]: {
    fontSize: '1.375rem',
    margin: '20px 0 40px'
  }
}))

export const ReferenceLink = styled(ExternalLink)(() => ({
  textDecoration: 'underline',
  fontWeight: 600,
  color: '#1C47CB'
})) as typeof ExternalLink
